import React from 'react';
import ReactNumberFormat from 'react-number-format';

// This is to remove an annoying warning about inputRef being passed down in props spread
// eslint-disable-next-line
const NumberFormat = ({ inputRef, ...rest }) => {
  return <ReactNumberFormat {...rest} />;
};

export default NumberFormat;
